import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../../lib/AuthContext";

const NEW_ROLES = new Set([
  "SUPER_ADMIN", "ACADEMY_ADMIN", "CONTENT_EDITOR", "MENTOR_REVIEWER",
  "FINANCE_MANAGER", "SUPPORT_AGENT", "FACILITATOR", "LEARNER",
]);
const LEGACY_MAP = { admin: "SUPER_ADMIN", user: "LEARNER" };

function resolveRole(u) {
  const r = u?.role || "LEARNER";
  return NEW_ROLES.has(r) ? r : (LEGACY_MAP[r] || "LEARNER");
}

/**
 * Block 2 (Mastermatrix v1.1 §15): Zentrale Frontend-Guards.
 * Der eigentliche Schutz bleibt IMMER serverseitig.
 * Diese Guards verbessern nur die Benutzerführung.
 */
export function RequireAuth({ children, redirectTo = "/auth/login" }) {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading) return <div className="min-h-screen" data-testid="require-auth-loading" />;
  if (!user) {
    const target = `${redirectTo}?redirect=${encodeURIComponent(location.pathname + location.search)}`;
    return <Navigate to={target} replace />;
  }
  return children;
}

export function RequireRole({ children, roles = [], redirectTo = "/" }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen" data-testid="require-role-loading" />;
  if (!user) return <Navigate to="/auth/login" replace />;
  const allowed = new Set(roles);
  if (!allowed.has(resolveRole(user))) {
    return <Navigate to={redirectTo} replace />;
  }
  return children;
}

export function useResolvedRole() {
  const { user } = useAuth();
  return user ? resolveRole(user) : null;
}
